import { notification } from 'antd';

import apiAuth from '../services/apiAuth';
import { groupBy } from './array';

class PermissoesHelper {
  static async getPermissoes(withGroup) {
    const { data: permissoes } = await apiAuth.get('/security', {
      params: {
        withGroup,
      },
    });

    return permissoes;
  }

  static agrupaPreferenciasPlataforma(permissoes) {
    const agrupadoPorGrupo = groupBy(permissoes, 'group');

    const preferenciasUsuario = {};

    Object.keys(agrupadoPorGrupo).forEach(grupo => {
      preferenciasUsuario[grupo] = groupBy(agrupadoPorGrupo[grupo], 'screen');
    });

    return preferenciasUsuario;
  }

  static async getPermissoesAgrupadas(withGroup) {
    let permissoes = {};

    try {
      const data = await this.getPermissoes(withGroup);

      if (data.length) {
        permissoes = withGroup
          ? this.agrupaPreferenciasPlataforma(data)
          : groupBy(data, 'screen');
      }
    } catch (err) {
      notification.error({
        message: 'Não foi possível recuperar as permissões',
        description:
          'Caso o problema persista, entre em contato com nosso suporte.',
      });
    }

    return permissoes;
  }
}

export default PermissoesHelper;
